import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton, Tooltip } from 'seagull';
import { AnchorGrayscale, ColorAnchor } from 'seagull/icons';
import { useLocaleKeys } from '~/i18n';
import { Intent } from '~/infra/access-control';
export default function EnterAccountantAccessButton(props) {
    const { t: texts } = useLocaleKeys('components.enterAccountantAccess');
    const { variant = 'default', testId, onClick } = props;
    const buttonProps = {
        bi: {
            name: 'enter_accountant_access'
        },
        noPadding: true,
        size: 'small',
        skin: 'transparent',
        testId: testId,
        onClick
    };
    return variant === 'default' ? /*#__PURE__*/ _jsx(Tooltip, {
        placement: "top",
        title: texts.goToClientPortal(),
        children: /*#__PURE__*/ _jsx(IconButton, _object_spread_props(_object_spread({}, buttonProps), {
            intent: Intent.EnterAccountantAccess,
            children: /*#__PURE__*/ _jsx(ColorAnchor, {
                size: 24
            })
        }))
    }) : /*#__PURE__*/ _jsx(Tooltip, {
        placement: "top",
        title: texts.pendingApproval(),
        children: /*#__PURE__*/ _jsx(IconButton, _object_spread_props(_object_spread({}, buttonProps), {
            cursorDefault: true,
            children: /*#__PURE__*/ _jsx(AnchorGrayscale, {})
        }))
    });
}
